/**
 * Adds the aidenProductCheck query param to the browser URL when the Aiden
 * quiz is opened from the pet quiz banner. Runs in the capture phase so the
 * URL is updated before the Aiden embed handles the click.
 */
(function () {
  if (window.petQuizBannerInitialized) return;
  window.petQuizBannerInitialized = true;

  var PARAM = 'aidenProductCheck';

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var button = target.closest('.pet-quiz-banner__btn[data-aiden-product-check]');
      if (!button) return;

      try {
        var url = new URL(window.location.href);
        if (url.searchParams.has(PARAM)) return;

        url.searchParams.set(PARAM, '');
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (error) {
        // Older browsers without URL support: leave the address bar untouched.
      }
    },
    true
  );
})();
